<template>
	<div>
		 <!-- breadcrumb area -->
		 <div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		     <div class="container">
		         <div class="breadcrumb-content text-center">
		             <h2>版权声明</h2>
		         </div>
		     </div>
		 </div>
		 <!-- Service details area -->
		 <div class="section section-padding">
		     <div class="container">
		         <div class="service-details-content">
					<p>
						1.	筑壳网（https://zikkkk.com)所有平台（包括但不限于网站，APP，小程序，社交账号等）发布的所有内容，包括但不限于图片及呈现方式，分类架构，数据结构，程序设计结构，版面设计等，均受国家相关法律法规保护，相应的版权、著作权等知识产权均归属筑壳网（https://zikkkk.com)所有。</p>
						<p>2.	在未获得筑壳网（https://zikkkk.com)书面授权的情况下，任何媒体，网站及个人不得转载、复制、修改、展示或使用筑壳网（https://zikkkk.com)的内容及服务，且不许在非筑壳网（https://zikkkk.com)所属服务器上建立镜像。如有上述行为，请自行删除，我们保留依法追究侵权主体法律责任的权利。</p>
						<p>3.	筑壳网（https://zikkkk.com)的资料版权属于第三方发布人或所属人，若信息不实或设计版权问题，需要版权方和第三方沟通，筑壳网配合对接，并在确认无误后删除设计版权问题，相应的法律责任与筑壳网（https://zikkkk.com)无关。
						</p>

					</p>
		         </div>  
		     </div>
		 </div>
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
	import {
		getShowList
	 } from '@/api'
	 export default {
	   data() {
			return {
				nameInfo: '',
				bgImg: require('../static/images/banner/banner-3.jpg'),
				showList: [],
			}
		},
		created() {
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods:{
			
			// 获取展厅详情
			async getShowList() {
			  const res = await getShowList()
			  this.showList = res.data
			},
		}
	}
</script>

<style>
</style>
